<template>
    <div>
        <div v-for="day in sortedDays" :key="day.id" class="itinerary-day">
            <div class="row">
                <div class="itinerary-day__title col-xs-12 col-md-4">
                    <day :day="day"></day>
                </div>

                <div class="itinerary-day__items col-xs-12 col-md-8">
                    <div v-for="item in day.itinerary_items" :key="item.id" class="itinerary-item-wrapper">
                        <itinerary-item
                            :item="item">
                        </itinerary-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItineraryItem from '@/components/ItineraryItem.vue';
import Day from '@/components/Day.vue';

export default {
    props: {
        days: {
            required: true
        },
    },

    components: {
        ItineraryItem,
        Day
    },

    data() {
        return {
            errors: {}
        }
    },

    computed: {
        sortedDays(){
            return this.days.sort((a,b)=>{
                let dateA = new Date(a.date), dateB = new Date(b.date);
                return dateA - dateB;
            }).map(day=>{
                if (day.itinerary_items) {
                    day.itinerary_items.sort((a,b)=>{
                        let dateA = new Date('1970/01/01 ' + a.time), dateB = new Date('1970/01/01 ' + b.time);
                        return dateA - dateB;
                    });
                }

                return day;
            });
        }
    },

    methods: {

    }
}
</script>

<style lang="scss">
.itinerary-display {
    &--purple {
        .day__time {
            color: $color-purple;
        }

        .itinerary-day {
            border-color: $color-purple;
            margin-bottom: 2rem;
        }

        & .itinerary-day:last-child {
            margin-bottom: 0;
        }
    }

    .itinerary-item-wrapper {
        border-bottom: 1px solid $color-light-blue;
        margin-bottom: 1rem;
    }

    div .itinerary-item-wrapper:last-child {
        border: none;
    }

    .itinerary-day__items {
        margin-bottom: 3rem;
    }

    .itinerary__create-day {
        margin-top: 1rem;
    }
}




</style>